// extracted by mini-css-extract-plugin
module.exports = {"header":"_3MCecY","label":"_3wmxwM","input":"_2rlUjK","form-radio":"_2-4UCt","form-checkbox":"_10UmuG"};